import React, { useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import GetHeader from "../components/getHeader"
import "../styles/about.css"

function age(birthdate) {
  const today = new Date();
  const age = today.getFullYear() - birthdate.getFullYear() - 
             (today.getMonth() < birthdate.getMonth() || 
             (today.getMonth() === birthdate.getMonth() && today.getDate() < birthdate.getDate()));
  return age;
}
const birthdate = new Date(1998, 11, 17); 

const About = (props) => {
  const location = useLocation()
  const wasRedirected = location.action === "PUSH" && !location.state.noChange ? true : null

  useEffect(() => {
    if (wasRedirected) {
      const darkness = document.getElementById("darkness")
      if (darkness) setTimeout(() => document.getElementById("darkness").remove(), 50)
    }
  }, [wasRedirected])

  const {
    myPic: {
      childImageSharp: { fluid: myPic },
    },
    arrowUp: {
      childImageSharp: { fixed: arrowUp },
    },
  } = useStaticQuery(graphql`
    {
      myPic: file(relativePath: { eq: "myPic.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      arrowUp: file(relativePath: { eq: "arrowUp.png" }) {
        childImageSharp {
          fixed(width: 27) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  if (props.pageContext.hebrew) {
    return (
      <Layout>
        <div id="about" className={wasRedirected ? "rollingPage active" : "rollingPage"}>
          <SEO
            title="אודות"
            description="מידע אודות איתי שיף. כל המידע על המסע שהוביל אותו להיות מפתח הפרונד אנד שהוא היום מלימוד עצמי."
            keywords={["היסטוריה", "אודות", "מידע על איתי שיף", "הקלדה מהירה"]}
          />

          <GetHeader />

          <section className="wrapper notHomepage">
            <div id="stars"></div>
            <div id="stars3"></div>

            <div id="innerWrapperContent" className="hebrew">
              <h1>אודות</h1>
              <h2>איתי שיף</h2>
            </div>
          </section>

          <div id="innerContentAbout" className="hebrew">
            <div>
              <span>
                <Image fluid={myPic} alt="תמונת פרופיל איתי שיף" />
              </span>
              <p>
                אני איתי שיף, בן {age(birthdate)}, מפתח Full Stack.
                <br />
                אני נהנה להתמודד עם אתגרים, להתאמן, לפתור בעיות, לצאת עם חברים, לשמוע מוזיקה, לכתוב קוד, להקליד, לנהל שיחות עמוקות וציניות טובה.
                <br />
                בזמן הפנוי שלי עובד כפרילנסר או על פרוייקט אחר שעוד לא מופיע פה.
              </p>
            </div>

            <div>
              תמיד הייתה לי את השאיפה ללמוד ולדעת עוד על מחשבים.
              <br />
              במשך השנה האחרונה התחלתי לקחת את השאיפה הזאת צעד קדימה ולהתחיל ללמוד, לממש את התשוקה הזו למשהו אמיתי, ולהפוך להיות מפתח פרונד אנד.
              <br />
              היו הרבה מאוד מקורות של מידע שהשתמשתי בהם בשביל ללמוד, אבל אני הכי אסיר תודה לאתר הזה{" "}
              <a href="https://javascript.info/" target="_blank" rel="noopener noreferrer">
                javascript.info
              </a>{" "}
              שלימד אותי את כל הבסיס (ויותר מזה) שהייתי צריך בשביל להתקדם ולהמשיך "לגדול".
            </div>

            <div className="forWhite">
              <div>
                <b>מה אהבת כל כך בלמידה עצמית, מה טוב בזה בכלל?</b>
                <ul>
                  <li>
                    אין אף אחד שמציק לך עם תוכנית לימודים קפדנית שאתה חייב לעקוב אחריה, יש לך כל החופשיות שבעולם להחליט מתי, איזה ואיך ללמוד טכנלוגיות בקצב שלך בלי שום מגבלות.
                  </li>
                  <li>
                    הקושי. האתגר שאתה עומד מולו הוא יותר קשה משום שיכול להיווצר מצב שאתה נתקל בבעיה שלא ראית לעולם לפני כן, ועכשיו הכל תלוי רק בך כדי לפתור אותה. יהיו אחרים שלא
                    יסכימו איתי ויגידו שזה דווקא "חסרון" ללמידה-עצמית. אני חושב שהם טועים בגלל שהתהליך המחקרי שאתה עושה בשביל להגיע לתשובה מלמד אותך המון והרגע הזה בסופו של דבר
                    באמת פותר את הבעיה הוא מדהים, מאשר מישהו שיתן לך פתרון פשוט כשיש עוד המון פתרונות שלא היית נחשף אליהם אם לא היית חוקר על הנושא.
                  </li>
                  <li> בסיום כל פרוייקט, אתה עובר עליו ומתרשם מהתוצאה. אתה שמח ומרוצה ממה שיצרת, בהסתכלות לאחור אתה מבין שעשית הכל לבד מבלי שאף אחד עזר לך.</li>
                </ul>
              </div>
            </div>

            <div>
              <b>מה הניע אותך לעשות את אותם פרוייקטים שאתה עשית?</b>
              <p>
                אם יצא לכם לעבור על הפרוייקטים שלי, בטח שמתם לב שכל אחד מהם עוסק בטכנולוגיה אחרת עם רעיון אחר.
                <br />
                כל פעם כשהתחלתי לעבוד על פרוייקט חדש, תכננתי אותו כך שיאתגר אותי באופן כזה שהפרוייקט הקודם לו לא איתגר אותי, זה היה גם אחלה של טריגר בשבילי לשמור על מוטיבציה גבוהה.
                <br />
                לפני שהתחלתי ליצור כל אחד מהם חקרתי וניתחתי איזה טכנולוגיה כדאי לי להשתמש לאותו פרוייקט כדי שהוא יצא אופטימלי ככל האפשר, תוך כדי התחשבות בטכנלוגיות האחרונות
                שהשתמשתי בהם.
                <br />
                ברגע שהרגשתי שיש לי מספיק ידע ואני מבין מספיק טכנולוגיה מסוימת אז הרגשתי שזה בסדר להתקדם לשלב הבא וללמוד את הטכנולוגיה הבאה (לדוגמה לא הייתי מתחיל ללמוד Gatsby לפני
                שהייתי מבין ושולט ב React, או לא הייתי מתחיל ללמוד framework לפני שקודם למדתי והתעסקתי עם Vanilla JavaScript).
              </p>
            </div>

            <div className="forWhite">
              <div>
                <b>מיומנויות אחרות שתרצה לחלוק</b>
                <ul>
                  <li>
                    מקום 1 בהקלדה מהירה בעברית בשנת 2016 לפי{" "}
                    <a href="https://10fastfingers.com/user/306954" target="_blank" rel="noopener noreferrer">
                      10fastfingers
                    </a>
                    , מקום 1 בהקלדה מהירה בעברית לפי TypeRacer נכון לעכשיו בממוצע של 150 מילים לדקה.
                  </li>
                  <li>
                    מוגדר במקום 78 כמקליד הכי מהיר באנגלית ב{" "}
                    <a href="https://data.typeracer.com/pit/profile?user=itay2468" target="_blank" rel="noopener noreferrer">
                      TypeRacer
                    </a>
                    , בממוצע של 170 מילים לדקה.
                  </li>
                  <li>שפת אם עברית, שוטף באנגלית.</li>
                </ul>
                <blockquote className="hebrew">” אם זה לא מאתגר אותך זה לא ישנה אותך “ &nbsp;&nbsp;-&nbsp;פרד דוויטו</blockquote>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <span className="hebrew">
            תודה על זמנך!{" "}
            <span role="img" aria-label="happy emoji">
              😊
            </span>
          </span>
          <div onClick={() => window.scrollTo(0, 0)} role="button" tabIndex={0}>
            <Image fixed={arrowUp} className="arrowUp" alt="חץ למעלה, קפוץ לתחילת העמוד" />
          </div>

          <small>© איתי שיף </small>
        </footer>

        {wasRedirected && <div id="darkness"></div>}
      </Layout>
    )
  }

  // Else render it in English
  return (
    <Layout>
      <div id="about" className={wasRedirected ? "rollingPage active" : "rollingPage"}>
        <SEO
          title="About"
          description="Who is Itay Shiff? All the information about his journey that brought him all the way to become a great Full Stack Developer."
          keywords={["About", "History Itay Shiff", "Fast Typing"]}
        />

        <GetHeader />
        <section className="wrapper notHomepage">
          <div id="stars"></div>
          <div id="stars3"></div>

          <div id="innerWrapperContent">
            <h1>About Me</h1>
            <h2>Itay Shiff</h2>
          </div>
        </section>
        <div id="innerContentAbout">
          <div>
            <span>
              <Image fluid={myPic} alt="itay shiff profile picture" />
            </span>
            <p>
              My name is Itay Shiff, I'm {age(birthdate)} years old and I'm a self taught Full Stack Developer.
              <br />
              I enjoy facing challenges, training, solving problems, going out with friends, listening to music, coding, typing, have meaningful conversations and good sarcasm.
              <br />
              Currently freelancing in my free time.
            </p>
          </div>

          <div>
            I have always been eager to learn and know more about computers.
            <br />
            In the last year I decided to take it a step forward and fulfill this passion. I started studying a lot and make it a real thing so that I can become a great Full Stack
            Developer.
            <br />
            There were tons of resources that were available for me and I used many, but I'm most grateful for{" "}
            <a href="https://javascript.info/" target="_blank" rel="noopener noreferrer">
              javascript.info
            </a>{" "}
            that taught me the basics (& much more) I needed to move on and keep growing.
          </div>

          <div className="forWhite">
            <div>
              <b>What did you like so much about studying by your own?</b>
              <ul>
                <li>
                  There's no one picking on you to follow a strict curriculum, which means you've the complete freedom to decide when, which and how you want to study technologies
                  at your own pace.
                </li>
                <li>
                  The challenge you face is harder because sometimes you might encounter a problem that you've never seen before, and it's all up to you to solve it. Others may
                  disagree with me and say this point is actually a "con" to self-studying. I think they're wrong because the process you make through by making your whole research
                  teaches you a lot, and when you actually get to the part you solved a problem is amazing, rather than someone who lands you a simple answer whereas there are way
                  more possible solutions for this problem you wouldn't been exposed to if you didn't make your research.
                </li>
                <li>Observing every finished product in the end make you happy and satisfied, realizing you've done it all by own without anyone out there to assist you.</li>
              </ul>
            </div>
          </div>

          <div>
            <b>What lead you creating the projects you've done?</b>
            <p>
              As you can tell from my projects, almost every one of them deals with different technologies and ideas.
              <br />
              I wanted each one of them to challenge me in some way that the previous project hasn't, that was a great trigger to keep me motivated.
              <br />
              Before getting into every project I made an analysis and research of what technologies I should use to make the next project as optimal as possible, while considering
              the last technologies I used.
              <br /> Once I felt I have quite good grasp of some technology so I felt it was fine moving on to the next step and learn the next technology (for example I wouldn't
              move on to learning Gatsby without mastering React first, or I wouldn't get into learning a framework before learning and dealing with vanilla JavaScript first).
            </p>
          </div>

          <div className="forWhite">
            <div>
              <b>Other skills to share</b>
              <ul>
                <li>
                  Fastest typist in Hebrew in 2016 in{" "}
                  <a href="https://10fastfingers.com/user/306954" target="_blank" rel="noopener noreferrer">
                    10fastfingers
                  </a>
                  , ranked 1<sup>st</sup> in TypeRacer Hebrew by now, 150wpm average.
                </li>
                <li>
                  Ranked 78<sup>th</sup> (Top 100) Fastest Typist in English in{" "}
                  <a href="https://data.typeracer.com/pit/profile?user=itay2468" target="_blank" rel="noopener noreferrer">
                    TypeRacer
                  </a>
                  , 170wpm average.
                </li>
                <li>Native in Hebrew, Fluent in English.</li>
              </ul>
              <blockquote>“If it doesn't challenge you it won't change you” &nbsp;&nbsp;-&nbsp;Fred DeVito</blockquote>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <span>
          Thank you for reading!{" "}
          <span role="img" aria-label="happy emoji">
            😊
          </span>
        </span>
        <div onClick={() => window.scrollTo(0, 0)} role="button" tabIndex={0}>
          <Image fixed={arrowUp} className="arrowUp" alt="arrow up, jump to top page" />
        </div>

        <small>Itay Shiff ©</small>
      </footer>

      {wasRedirected && <div id="darkness"></div>}
    </Layout>
  )
}

export default About
